<template>
  <div style="width:1200px;margin:0 auto;">
    <div v-if="teamData.status==3" class="team_success">
      <div>
        <div class="team_success_img"><img :src="failure" alt=""></div>
        <div class="team_success_txt">拼单失败</div>
      </div>
      <div class="team_success_goodsname">商品名称：{{teamData.goodsName}} {{teamData.goodsUnitName}} {{teamData.property1}}</div>
      <div class="team_list_box" ref="team_list_box">
        <ul class="team_list clearfix_" ref="team_list">
          <li class="fl" v-for="(item,index) in arr" :key="index">
            <p class="team_item" v-show="item"><img :src="item.iconImg" alt=""></p>
            <p class="team_item" v-show="!item">?</p>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="teamData.status==2" class="team_success">
      <div>
        <div class="team_success_img"><img :src="teamSuccess" alt=""></div>
        <div class="team_success_txt">拼单成功</div>
      </div>
      <div class="team_success_goodsname">商品名称：{{teamData.goodsName}} {{teamData.goodsUnitName}} {{teamData.property1}}</div>
      <div class="team_list_box" ref="team_list_box">
        <ul class="team_list clearfix_" ref="team_list">
          <li class="fl" v-for="(item,index) in arr" :key="index">
            <p class="team_item" v-show="item"><img :src="item.iconImg" alt=""></p>
            <p class="team_item" v-show="!item">?</p>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="teamData.status==1" class="team_stay_invitation">
      <div class="team_stay_invitation_img"><img :src="pic" alt=""></div>
      <div class="team_stay_invitation_num">还差 <span>{{teamData.returnNum}}</span> 人，赶紧邀请好友来拼单吧</div>
      <div class="team_success_goodsname">商品名称：{{teamData.goodsName}} {{teamData.goodsUnitName}} {{teamData.property1}}</div>
      <div class="team_list_box" ref="team_list_box">
        <ul class="team_list clearfix_" ref="team_list">
          <li class="fl" v-for="(item,index) in arr" :key="index">
            <p class="team_item" v-show="item"><img :src="item.iconImg" alt=""></p>
            <p class="team_item" v-show="!item">?</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="team_success_team_goods">
      <div class="team_success_team_goods_title clearfix_">
        <span class="fl">最新拼团</span>
        <span class="fr team_success_team_goods_title_more"><router-link target="_blank" :to="{name:'teamGoods'}">更多>></router-link></span>
      </div>
      <div class="GoodsListContentBox">
          <ul class="clearfix">
          <li v-for="(goods,index) in teamGoodsList" :key="index" :data-id="goods.id" @mouseenter="hover(index)" @mouseleave="leave(index)">
            <router-link tag="a" target="_blank" :to="{name:'goodsdetails',query: {goodsId:goods.goodsId}}">
              <div class="goodslistpicbox">
                <img :title="goods.goodsName" :src="goods.goodsHeadpicPath1?goods.goodsHeadpicPath1:noImg" width="225" height="225" :goodsId="goods.goodsId"/>
              </div>
            </router-link>
              <div class="goodslistprice clearfix_">
                <p class="fl">{{goods.originalPrice}}</p>
                <p class="fr teamPriceAndNum clearfix_"><span class="fl">¥{{goods.price}}</span><i class="fl">{{goods.val}}人拼</i></p>
              </div>
            <router-link tag="a" target="_blank" :to="{name:'goodsdetails',query: {goodsId:goods.goodsId}}">
              <div class="goodslistnamebox">
                <p :title="goods.goodsName">{{goods.goodsName}}</p>
              </div>
            </router-link>
            <div class="clearfix_">
              <div class="goodslistBtnBox fl" v-show="Accord === index" @click="goToGoods(goods.goodsId)">查看详情</div>
              <div class="goodslistBtnBox fl" v-show="Accord === index" @click="goToGoods(goods.goodsId)">加入购物车</div>
            </div>
          </li>
        </ul> 
        <div class="noGoods" v-show="iscategoryList">暂时没有商品哦~！快去看看其他好商品吧~！</div> 
      </div>
    </div>
  </div>
</template>
<script>
import memberHeader from '@/components/member/member_header'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
import BScroll from "better-scroll"
export default {
  data(){
    return {
      teamData:{},
      arr:[],
      iscategoryList:false,
      teamSuccess:require('../../assets/img/team_success.png'),
      failure:require('../../assets/img/failure.png'),
      pic:'',
      teamGoodsList:[],
      Accord:-1,
      noImg:require("@/assets/img/aa.png")
    }
  },
  mounted:function(){
    this.getData()
    this.getTeamGoods()
  },
  created() {
    setTimeout(() => {
      this.personScroll()
    }, 300)
  },
  methods:{
    goToGoods:function(goodsId){
      var t_=this
      var href=this.$router.resolve( {name:'goodsdetails',query: {goodsId:goodsId}})
      return window.open(href.href,'_blank')
    },
    hover:function (index) {
      this.Accord = index
    },
    leave:function (index) {
      this.Accord = null
    },
    personScroll() {
      let width = this.arr.length * 70 + (this.arr.length-1)*30
      this.$refs.team_list.style.width = width + "px"
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.team_list_box, {
            startX: 0,
            click: true,
            scrollX: true,
            scrollY: false,
            eventPassthrough: "vertical"
          })
        } else {
          this.scroll.refresh()
        }
      })
    },
    getTeamGoods:function(){
      var t_=this
      var data0bj = {
          channel: 2,
          tamp:localStorage.tamp?localStorage.tamp:'',
          page:1,
          pagesize:12
      }
      var u = `${ip}spellGroupInterface/getCategoryById`
      axios.post(u,Qs.stringify(data0bj)).then(res=>{
        if( res.data.code == 0 ){
          if(overtime(res.data.code)){
            localStorage.removeItem('tamp')
            localStorage.removeItem('name')
            return this.$router.push({
              path: '/LoginHome?state=1',
              query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
            });
            this.$router.go(0);
          }
          if(res.data.code==300){
            var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
            return window.open(href.href,'_blank')
          }
          if(res.data.code==0){
            if(res.data.results.total==0)return t_.iscategoryList=true
            t_.teamGoodsList=res.data.results.rows
          }
        }
      })
    },
    sweepCodePurchase:function(){
      var data0bj = {
          goodsId:this.teamData.goodsId,
          channel: 2,
          tamp:localStorage.tamp?localStorage.tamp:''
      }
      var u = `${ip}formWorkInterface/getXcxQrcode`
      axios.post(u,Qs.stringify(data0bj))
      .then(res => {
        if( res.data.code == 0 ){
          if(overtime(res.data.code)){
            localStorage.removeItem('tamp')
            localStorage.removeItem('name')
            return this.$router.push({
              path: '/LoginHome?state=1',
              query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
            });
            this.$router.go(0);
          }
          if(res.data.code==300){
            var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
            return window.open(href.href,'_blank')
          }
          this.pic = `${ip}${res.data.url}`
        }
      })
    },
    getData:function(){
      var t_=this
      var data0bj = {
        channel: 2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        retailSpellGroupOrderId:t_.$route.query.id
      }
      var u = `${ip}spellGroupInterface/spellGroupOrderById`
      axios.post(u,Qs.stringify(data0bj)).then(res=>{
        if( res.data.code == 0 ){
          if(overtime(res.data.code)){
            localStorage.removeItem('tamp')
            localStorage.removeItem('name')
            return this.$router.push({
              path: '/LoginHome?state=1',
              query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
            });
            this.$router.go(0);
          }
          if(res.data.code==300){
            var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
            return window.open(href.href,'_blank')
          }
          if(res.data.code==0){
            t_.teamData=res.data.data
            t_.arr=res.data.data.memberData
            if(t_.teamData.status==1)t_.sweepCodePurchase()
          }
        }
      })
    }
  }
}
</script>
<style scoped>
  .team_success,.team_stay_invitation{
    margin-top: 30px;
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #f4f4f4;
  }
  .team_success_img{
    margin-bottom: 15px;
  }
  .team_success_img img{
    width: 80px;
    height: 80px;
    display: inherit;
    margin: 0 auto;
  }
  .team_success_txt{
    font-size: 20px;
    color:#333;
    font-weight: 900;
    text-align: center;
  }
  .team_success_goodsname{
    margin-top: 30px;
    text-align: center;
    font-size: 14px;
  }
  .team_list_box{
    width: 100%;
    height: 70px;
    margin-top: 30px;
    overflow: hidden;
    /* width: 300px; */
  }
  .team_list{
    height: 70px;
     margin: 0 auto; 
  }
  .team_item{
    width: 68px;
    height: 68px;
    border:1px solid #000;
    border-radius: 50%;
    font-size: 38px;
    color: #999;
    text-align: center;
    line-height: 70px;
    overflow: hidden;
  }
  .team_list li{
    margin-right: 30px;
  }
  .team_list li:last-child{
    margin-right: 0;
  }
  .team_item img{
    width: 68px;
    height: 68px;
  }
  .team_success_team_goods_title{
    margin-bottom: 20px;
  }
  .team_success_team_goods_title_more{
    cursor: pointer;
  }
  .GoodsListContentBox ul li{
    width: 224px;
    height: 352px;
     padding: 10px;
    margin-right: 2px;
    float: left;
    margin-bottom: 10px;
    border: 1px solid white;
  }
  .GoodsListContentBox ul li:nth-child(4n+0){
    margin-right: 0;
  }
  .GoodsListContentBox ul li:hover{
    border: 1px solid #eaeaea;
    border-radius: 3px;
    box-shadow: 0 0 1px #999;
  }
  .GoodsListContentBox ul li a{
    text-decoration: none;
  }
  .goodslistpicbox{
    height: 235px;
    border-bottom: 1px solid #EEEEEE;
  }
  .goodslistprice p{
    height: 45px;
    line-height: 45px;
    text-align: left;
    color: #FF6600;
    font-size: 22px;
  }
  .goodslistnamebox p{
    text-align: left;
    font-size: 12px;
    color: #313030;
    height: 35px;
    line-height: 19px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .goodslistnamebox p:hover{
    color: #FF6600;
    text-decoration: underline;
  }
  .goodslistoptionbox{
    width: 100%;
    height: 30px;
  }
  .goodslistoptionbox .goodslistLeftBox{
    width: 50%;
    height: 35px;
    float: left;
    text-align: left;
    line-height: 35px;
    color: #313030;
  }
  .goodslistoptionbox .goodslistLeftBox span{
    color: #2272C8;
    font-weight: 600;
  }
  .goodslistoptionbox .goodslistRightBox{
    float: left;
    text-align: right;
    width: 50%;
    height: 35px;
    line-height: 35px;
    color: #313030;
  }
  .goodslistBtnBox{
    cursor: pointer;
    width: 112px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #FF6600;
    font-size: 14px;
    border-top: 1px solid #eee;
    margin-top: 10px;
    border-right: 1px solid #eee;
    /*display: none;*/
  }
  .goodslistBtnBox:first-child{
    width: 111px;
  }
  .goodslistBtnBox:last-child{
    border-right: 0;
  }
   /* .el-pagination .el-pagination__jump{
    margin-top:-10px;
  } */
  .goodslistprice  .teamPriceAndNum{
    font-size: 14px;
  }
  .goodslistprice  .teamPriceAndNum span{
    margin-right: 5px;
  }
  .goodslistprice  .teamPriceAndNum  i{
    width: 55px;
    height: 18px;
    background:#f60;
    line-height: 18px;
    text-align: center;
    color:#fff;
    margin-top: 13px;
  }
  .team_stay_invitation_img{
    width: 110px;
    height: 110px;
    overflow: hidden;
    margin: 0 auto;
    margin-bottom: 30px;
  }
  .team_stay_invitation_img img{
    width: 110px;
    height: 110px;
  }
  .team_stay_invitation_num{
    text-align: center;
    font-size: 14px;
    color:#666;
  }
  .team_stay_invitation_num span{
    font-size: 26px;
    color:#f12002;
  }
  .team_success_team_goods .GoodsListContentBox li{
    margin-right: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/the_final_results.vue